const GTM_CONTAINER_ID = process.env.NEXT_PUBLIC_GTM_CONTAINER_ID;
const GTM_AUTH = process.env.NEXT_PUBLIC_GTM_AUTH;
const GTM_PREVIEW = process.env.NEXT_PUBLIC_GTM_PREVIEW;

function getNoScriptUrl() {
  if (!GTM_CONTAINER_ID) return null;

  if (GTM_AUTH && GTM_PREVIEW) {
    return `https://www.googletagmanager.com/ns.html?id=${GTM_CONTAINER_ID}&gtm_auth=${GTM_AUTH}&gtm_preview=${GTM_PREVIEW}&gtm_cookies_win=x`;
  }

  return `https://www.googletagmanager.com/ns.html?id=${GTM_CONTAINER_ID}`;
}

export default function GoogleTagManagerNoScript() {
  const noscriptUrl = getNoScriptUrl();

  if (!noscriptUrl) return null;

  return (
    <noscript>
      <iframe
        src={noscriptUrl}
        height="0"
        width="0"
        hidden
        aria-hidden="true"
      />
    </noscript>
  );
}
